import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {
    value: boolean
    falseText?: string
    trueText?: string
    hideIcon?: boolean
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const Lock = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');
    
    const falseText = props.falseText || t('no');
    const trueText = props.trueText || t('yes');
    return (<Typography variant="body1">
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {props.hideIcon ? null : props.value ? <LockIcon fontSize="small" /> : <LockOpenIcon fontSize="small" />}
        {props.value ? trueText : falseText}
        </span>
    </Typography>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));